import React from 'react';
import { RoomAvailabilityType } from '../../../types.ts';
import { styled } from 'styled-components';
import { StyledTH } from '../styled.ts';

const StyledHeaderElement = styled(StyledTH)<{ dateDayOfWeek: string }>`
  padding: unset !important;
  background-color: ${({ dateDayOfWeek }) =>
    dateDayOfWeek == 'Saturday' || dateDayOfWeek == 'Sunday' ? 'darkgrey' : 'grey'};
`;

interface DateDaysProps {
  availability: RoomAvailabilityType;
}

const DateDays: React.FC<DateDaysProps> = ({ availability }) => (
  <StyledHeaderElement dateDayOfWeek={availability.ForDateDayOfWeek}>
    <span>{availability.ForDateDayOfMonth}</span>
    <br />
    <span>{availability.ForDateDayOfWeek.charAt(0)}</span>
  </StyledHeaderElement>
);

export default DateDays;
